import './App.css';
import {Col, Row, Typography} from 'antd';

const { Title} = Typography;

function Register() {
  return (
      <Row className={'page-row'} style={{
          minHeight: 220,
          maxWidth: 1024,
          margin: '24px auto 0 auto'
      }}>
          <Col span={24}>
              <Title level={3}>Register</Title>
              <p>Site is under construction please come back latter.</p>
          </Col>
      </Row>
  );
}

export default Register;
